import axios from 'axios'
import { Message } from 'element-ui'
import VueCookies from 'vue-cookies'


import router from "@/router";
import VueI18n from 'vue-i18n';
import { getReqUrl,needbuy,getLang,UrlDecode,getValue,setValue } from "@/utils/pub"


//cnpm install crypto-js --save-dev
//cnpm install js-md5 --save-dev

let AUTH_TOKEN=(function(){

  return getValue("token");
})();
let USERID=(function(){
  return getValue("userid");
})();
let staffid=(function(){
  return getValue("staffid");
})();
let role=(function(){
  var rolee= getValue("role");
  if(rolee==undefined){
     return "1";
  }
  return rolee;
})();
//let puburl=getReqUrl()
const HTTP = axios.create({

  // 基础url前缀
  baseURL: getReqUrl()+'/',

  // transformRequest: [function (data) { //json to form data
  //   return qs.stringify(data)
  // }],


});

const HTTPJson = axios.create({

  // 基础url前缀
  baseURL: getReqUrl()+'/',

  // transformRequest: [function (data) { //json to form data
  //   return qs.stringify(data)
  // }],


});

//HTTP.defaults.headers.common["Authorization"] = 'Bearer '+AUTH_TOKEN;

let message


HTTP.interceptors.request.use(config => {
  //config.withCredentials = true // 允许携带token ,这个是解决跨域产生的相关问题
  config.headers = {
    'Content-Type':'application/x-www-form-urlencoded'
  }
  let token = getValue("token")
  //this.alert_ok("request token="+token)
  //let csrf = store.getters.csrf
  if (token) {
   config.headers = {
    'Authorization': token,
    'Content-Type': 'application/x-www-form-urlencoded'
   }
   config.params = {'userid':getValue("userid"),'staffid':getValue("staffid"),'role':getValue("role"),'apiversion':2.1}
  }else{
    config.params = {'userid':getValue("userid"),'apiversion':2.1}
  }

  return config
}, (error) => {
  return Promise.reject(error)
})



// response拦截器
HTTP.interceptors.response.use(
  response => {
    var data = response.data
    if (data.code == 2 || data.code == 404) {
      router.push({name:'login'});
      return Promise.reject(new Error('token error'))
    } else if (data.code == 5) {
      Message.error('Permission Denied')
      return Promise.reject(new Error('Permission Denied'))
    } else if (data.code == 10) {
      if (needbuy()) {
        Message.error('You need to purchase to continue use')
        router.push({name:'InAppPurchase'});
        return Promise.reject(new Error('need purchase'))
      }
    } else if (data.code == undefined && typeof data === 'string') {
      if (data.indexOf('"code":2') > 0 || data.indexOf('token error') > 0) {
        router.push({name:'login'});
        return Promise.reject(new Error('token error'))
      }
    }
    return response;
  },
  error => {
    if (error && error.response) {
      Message.error(error.message || 'Request error')
    } else {
      Message.error(error.message || 'Network error')
    }
    return {error: -1, data: ''}
  }
)
export function ConnectDb(data) {
  return HTTP({
    url: '/httpBusiness/connectdb.ashx',
    method: 'POST',
    data:data
  })
}

export function Login(data) {
  return HTTP({
    url: '/AjaxFunction/Login.ashx',
    method: 'POST',
    data:data
  })
}
export function UploadData(data) {
  //console.log("111")
  return HTTP({
    url: '/httpBusiness/AddData.ashx',
    method: 'POST',
    data:data
  })
}
export function Supplier(data) {
  return HTTP({
    url: 'v1/Supplier',
    method: 'GET'
  })
}

export function SupplierCreate(data) {
    return HTTP({
        url: 'v1/Supplier',
        method: 'PUT',
        data:data
    })
}



export function SupplierGet(id) {
  return HTTP({
    url: 'v1/Supplier/' + id,
    method: 'GET'
  })
}

export function SupplierDelete(id) {
  return HTTP({
    url: 'v1/Supplier/' + id,
    method: 'DELETE'
  })
}

export function SupplierBindServer(id) {
  return HTTP({
    url: 'v1/Supplier/' + id + '/binds',
    method: 'GET'
  })
}
export function UploadOrder(data) {
  return HTTP({
    url: '/httpBusiness/UploadInvoicing.ashx',
    method: 'POST',
    data:data
  })
}
export function BindServerCreate(data) {
  return HTTP({
    url: 'v1/binds',
    method: 'PUT',
    data:data
  })
}

export function BindDelete(data) {
  return HTTP({
    url: 'v1/binds',
    method: 'DELETE',
    data:data
  })
}
export function openurl(data) {
  return HTTP({
    url: '/api/openurl',
    method: 'POST',
    data:data
  })
}
export function GetTypeList(belong) {
  return HTTP({
    url: '/httpbusiness/jxc/getList.ashx?belong='+belong,
    method: 'POST',
    data:belong
  })
}
export function GetList(table,pageid,pagesize) {
  return HTTP({
    url: '/httpbusiness/jxc/getList.ashx?table='+table+'&pageid='+pageid+'&pagesize='+pagesize,
    method: 'POST',
    data:belong
  })
}
export function AddData(data) {
  return HTTP({
    url: '/httpBusiness/AddData.ashx',
    method: 'POST',
    data:data
  })
}
export function PostChat(data) {
  return HTTP({
    url: '/httpbusiness/chatgpt',
    method: 'POST',
    data:data
  })
}

export function AddJsonData(data) {


  return  HTTP.request({
    url: '/httpBusiness/AddJsonData',
    method: 'post',
    headers: {
      'Authorization': getValue("token"),
      'Content-Type':'application/json;charset=UTF-8'
    },
    data:JSON.stringify(data)
  })



}


export function getneedbuy() {
  return HTTP({
    url: '/httpbusiness/getneebbb.ashx',
    method: 'POST',

  })
}
export function GetStockList(data) {
  return HTTP({
    //url: '/httpbusiness/jxc/getStockList.ashx',
    url: '/httpbusiness/jxc/getList.ashx',
    method: 'POST',
    data:data
  })
}
//url: 'http://www.iosbuy.com/httpBusiness/CheckIsBuy.ashx',
//url := "http://www.iosbuy.com/httpBusiness/CheckIsBuy.ashx?appid=0001&appname=buyInvoiceServer&apiversion=2.11&userid=" + userid + "&language=" + public.GetLanguage() + "&sign=" + sign
export function CheckBuy(data) {
  return HTTP({
    url: 'https://www.iosbuy.com/httpbusiness/checkbuy.ashx',
    method: 'POST',
   data:data,
  })
}

export function TypeGet(belong) {
  return HTTP({
    url: '/httpbusiness/jxc/getList.ashx?table=producttype&belong=' + belong,
    method: 'GET'
  })
}
export function GetDataList(data) {
//console.log("data="+data);
   if (typeof data === "string") {
  // Check if string already has userid=
  if (!data.includes("userid=")) {
    // Append userid
    data += "&userid="+getValue("userid");
  }
}

  return HTTP({
    url: '/httpbusiness/jxc/getList.ashx',
    method: 'POST',
    data:data
  })
}
export function UpdateQty(data) {
  return HTTP({
    url: '/httpbusiness/updateqty',
    method: 'POST',
    data:data
  })
}

export function GetDataById(data) {
  return HTTP({
    url: '/httpbusiness/jxc/getdatabyid.ashx',
    method: 'POST',
    data:data
  })
}
export function AddOrder(data) {
  return HTTP({
    url: '/httpbusiness/UploadInvoicing.ashx',
    method: 'POST',
    data:data
  })
}
export function GetPrintData(data) {
  return HTTP({
    url: '/httpbusiness/jxc/getprintdata.ashx',
    method: 'POST',
    data:data
  })
}
export function GetUserInfo(data) {
  return HTTP({
    url: '/AjaxFunction/getUserInfo.ashx',
    method: 'POST',
    data:data
  })
}

export function GetExcel(params) {

  var puburl=getReqUrl();
        //this.alert_ok(puburl);

        if (params.indexOf("userid")<0){
          params+="&userid="+getValue("userid")
        }
        var productset=getValue("productset")

        if(productset=="hascolor"){
          params+="&hascolor=1";
        }else{

        }
           var url=puburl+'/httpbusiness/exportexcel?'+params;
          window.open(url, '_blank');
}

export function DeleteData(table,id) {
  return HTTP({
    url: '/httpBusiness/DeleteData.ashx?table='+table+'&id=' + id,
    method: 'POST'
  })
}
export function DeleteImage(userid,pid,imagename) {
  return HTTP({
    url: '/httpbusiness/deleteimage?userid='+userid+'&pid=' + pid+'&imagename=' + imagename,
    method: 'POST'
  })
}
export function UploadImage(data) {
  //console.log("111")
  return HTTP({
    url: '/httpbusiness/addimage',
    method: 'POST',
    data:data
  })
}
//go public.HttpGet("http://www.iosbuy.com/httpBusiness/CheckVersion.ashx?appname=InvoiceServer" + public.GetOSName() + "&version=" + HTTPBusiness.SerVersion)
export function GetNewVersion() {
  return HTTP({
    url: 'http://www.iosbuy.com/httpBusiness/CheckVersion.ashx?appname=InvoiceServer&version=1.43',
    method: 'GET'
  })
}
export function GetLocalVersion() {
  return HTTP({
    url: '/httpbusiness/jxc/getList.ashx?table=getversion',
    method: 'GET'
  })
}

export function GetStatistics(userid,flag) {
  return HTTP({
    url: '/httpbusiness/jxc/getList.ashx?table=statistics&userid='+userid+'&flag='+flag,
    method: 'GET'
  })
}
export function CheckVersion() {
  return HTTP({
    url: '/httpbusiness/jxc/getList.ashx?table=checkversion',
    method: 'GET'
  })
}
export function Apis() {
  return HTTP({
    url: '/v1/apis?limit=1000',
    method: 'GET'
  })
}

export function ApisCreate(data) {
  return HTTP({
    url: '/v1/apis',
    method: 'PUT',
    data:data
  })
}

export function ApisGet(id) {
  return HTTP({
    url: '/v1/apis/' + id,
    method: 'GET'
  })
}

export function ApisDelete(id) {
  return HTTP({
    url: '/v1/apis/' + id,
    method: 'DELETE'
  })
}
//api统计
export function Export() {
  return HTTP({
    url: '/v1/apidb/api_info',
    method: 'POST',
  })
}
//网关管理
export function Import() {
  return HTTP({
    url: '/v1/apidb/api_stats',
    method: 'POST'
  })
}

//集群服务
export function Servers() {
  return HTTP({
    url: '/v1/servers',
    method: 'GET'
  })
}







// WEBPACK FOOTER //
// ./src/api/index.js